import apiClient from './client'

export interface TranscribeResponse {
  text: string
  duration: number
}

/** Расширение файла записи по её MIME-типу. */
export function audioExt(mime: string): string {
  const t = mime.toLowerCase()
  if (t.includes('ogg')) return 'ogg'
  if (t.includes('webm')) return 'webm'
  if (t.includes('mp4') || t.includes('m4a')) return 'mp4'
  if (t.includes('mpeg') || t.includes('mp3')) return 'mp3'
  return 'wav'
}

export const transcribeApi = {
  /**
   * POST /api/v1/assistants/{assistantId}/transcribe
   * Sends audio blob for speech-to-text transcription.
   *
   * groupId сужает подсказку распознавания до состава одной группы. На экране
   * переклички это заметно точнее: полтора десятка фамилий вместо всей базы,
   * где похожие имена легко перепутать.
   */
  transcribe: async (
    assistantId: string,
    audioBlob: Blob,
    groupId?: string
  ): Promise<TranscribeResponse> => {
    const formData = new FormData()
    // Расширение по MIME: распознавание определяет формат по имени файла.
    // Safari (iPhone) пишет audio/mp4 - раньше он уходил как voice.wav.
    const ext = audioExt(audioBlob.type)
    formData.append('audio', audioBlob, `voice.${ext}`)

    const response = await apiClient.post<TranscribeResponse>(
      `/assistants/${assistantId}/transcribe`,
      formData,
      groupId ? { params: { group_id: groupId } } : undefined
    )
    return response.data
  },
}
